import { usePintMaster, createControlField } from '@lib/common';
import { TextField } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import styled from 'styled-components';

const CountryField = ({ value, onChange }) => {
  const { loading, master: countries } = usePintMaster('countries');
  return (
    <CountryStyles>
      <Autocomplete
        multiple
        size="small"
        value={value}
        onChange={(evt, v) => onChange && onChange(v)}
        loading={loading}
        disabled={loading}
        options={countries || []}
        getOptionLabel={value => value.name}
        renderInput={props => (
          <TextField
            helperText="Select the origin country for this content."
            label={loading ? 'Origin Country (Loading...)' : 'Origin Country'}
            placeholder={loading ? 'Country (Loading...)' : 'Country'}
            fullWidth
            variant="outlined"
            {...props}
          />
        )}
      />
    </CountryStyles>
  );
};

const CountryStyles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

export const OriginCountryField = createControlField(CountryField, []);
